<template>
	<div class="main-container">

    <HeaderPiedPro/>
    <AccueilPiedPro/>
		<!-- Navbar section -->
<!--		<HeaderAgencyPiedProLanding />-->

<!--    <div class="row-fluid">-->
<!--      &lt;!&ndash; For Desktop view&ndash;&gt;-->
<!--      <div v-if="!isMobile()" class="col-lg-12" style="padding: 0px;">-->
<!--        <img class="portrait" alt="Dr Rita El-Khoury - podiatre" src="../../assets/img/pied-pro/Dr_Rita_El-Khoury_Podiatre.png">-->

<!--        <div class="row hero-item">-->
<!--          <div class="col-12 hero-content">-->
<!--            <h1 class="text-right hero-content-title">-->
<!--              <strong style="color:#0f306e">vos </strong>-->
<!--              <strong style="color:#b6802e">pieds </strong>-->
<!--              <br>-->
<!--              <strong style="color:#0f306e">notre </strong>-->
<!--              <strong style="color:#b6802e">compétence </strong>-->
<!--            </h1>-->
<!--            <h6 class="text-center" style="font-size: x-large; padding-top: 100px;">-->
<!--              <p>-->
<!--                Ongles incarnés<i class="fas fa-circle text-service-separator"></i>-->
<!--                <i style="font-style: normal; color: black">Verrues plantaires</i> <i class="fas fa-circle text-service-separator"></i>Douleur aux pieds-->
<!--              </p>-->
<!--              <p>-->
<!--                <i style="font-style: normal; color: black">Transpiration excessive</i>-->
<!--                <i class="fas fa-circle text-service-separator"></i>Pieds Diabétiques-->
<!--                <i class="fas fa-circle text-service-separator"></i>-->
<!--                <i style="font-style: normal; color: black">Soins des pieds</i>-->
<!--              </p>-->
<!--              <p>-->
<!--                <i style="font-style: normal; color: black">Orthèses plantaires sur mesure</i>-->
<!--              </p>-->
<!--            </h6>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="row" style=" background-color:#0f306e; display: inherit; padding: 20px; margin: 0px;">-->
<!--&lt;!&ndash;        <div class="row" style=" background-color:#0f306e; display: inherit; padding: 20px; height: calc(100% - 100px);">&ndash;&gt;-->
<!--          <div class="col-12 text-right h5 text-white" >-->
<!--            Dre Rita El-Khoury, podiatre-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      &lt;!&ndash; For Mobile view&ndash;&gt;-->
<!--      <div v-else>-->
<!--        <div class=" hero-item" style="margin-left: 0px; margin-right: 0px; display: block">-->
<!--          <div class="col-12 hero-content"-->
<!--               style="margin-left: 0px; margin-right: 0px; display: block">-->
<!--            <h1 class="text-center hero-content-title">-->
<!--              <strong style="color:#0f306e">vos </strong>-->
<!--              <strong style="color:#b6802e">pieds </strong>-->
<!--              <br>-->
<!--              <strong style="color:#0f306e">notre </strong>-->
<!--              <strong style="color:#b6802e">compétence </strong>-->
<!--            </h1>-->
<!--&lt;!&ndash;            <div>&ndash;&gt;-->
<!--              <img class="portrait"-->
<!--                   alt="Dr Rita El-Khoury - podiatre"-->
<!--                   src="../../assets/img/pied-pro/Dr_Rita_El-Khoury_Podiatre.png"-->
<!--                   style="float: right">-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--            <h6 class="text-left" style="font-size: medium; clear: left; padding-top: 15px;">-->
<!--              <span>-->
<!--                Ongles incarnés-->
<!--                <hr class="solid">-->
<!--                <i style="font-style: normal; color: black">Verrues plantaires</i>-->
<!--                <hr class="solid">-->
<!--                Douleur aux pieds-->
<!--                <hr class="solid">-->
<!--                <i style="font-style: normal; color: black">Transpiration excessive</i>-->
<!--                <hr class="solid">-->
<!--                Pieds Diabétiques-->
<!--                <hr class="solid">-->
<!--                <i style="font-style: normal; color: black">Soins des pieds</i>-->
<!--                <hr class="solid">-->
<!--                Orthèses plantaires sur mesure-->
<!--                <hr class="solid">-->
<!--              </span>-->
<!--            </h6>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="container row" style=" background-color:#0f306e; padding: 20px; margin-left: 0px; margin-right: 0px;">-->
<!--          &lt;!&ndash;        <div class="row" style=" background-color:#0f306e; display: inherit; padding: 20px; height: calc(100% - 100px);">&ndash;&gt;-->
<!--          <div class="col-12 text-right h5 text-white" >-->
<!--            Dre Rita El-Khoury, podiatre-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <PiedProdServicesContainer BgGradient="blue" />
    <EquipePiedPro/>
    <ContactFormPiedPro :style="bgImg"/>
    <FooterMainPiedPro/>

    <!-- hero section -->
<!--		<HeroDigitalAgencyPiedProLanding />-->

    <!-- offcanvas search component -->
    <OffcanvasSearchBox />

	</div>
</template>

<script>
	// import HeaderAgencyPiedProLanding from "@/components/HeaderAgencyPiedProLanding";
	// import HeroDigitalAgencyPiedProLanding from "@/components/sections/HeroDigitalAgencyPiedProLanding";
	import OffcanvasSearchBox from "@/components/OffcanvasSearchBox";
	// import ClinicServiceDescription from "@/pages/piedPro/ClinicServiceDescription";
  import PiedProdServicesContainer from "@/components/pied-pro-custom/PiedProServicesContainer";
  import HeaderPiedPro from "@/components/pied-pro-custom/HeaderPiedPro";
  import AccueilPiedPro from "@/components/pied-pro-custom/AccueilPiedPro";
  import ContactFormPiedPro from "@/components/pied-pro-custom/ContactFormPiedPro";
  import FooterMainPiedPro from "@/components/pied-pro-custom/FooterMainPiedPro";
  import EquipePiedPro from "@/components/pied-pro-custom/EquipePiedPro";



  export default {
		name: "app",
		components: {
      // HeaderAgencyPiedProLanding,
      // HeroDigitalAgencyPiedProLanding,
      OffcanvasSearchBox,
      PiedProdServicesContainer,
      HeaderPiedPro,
      AccueilPiedPro,
      ContactFormPiedPro,
      FooterMainPiedPro,
      EquipePiedPro
		},
    data (){
      return {
        bgImg: {
          backgroundImage: `url(${require('@/assets/img/pied-pro/services/podiatre-background3.jpg')})`,
          backgroundSize: "cover",
          backgroundPosition: "50%",
          // opacity:"0.5",
          position: "relative",
          width: "100%"
        }
      }
    },
    methods: {
      isMobile() {
        if( screen.width <= 1060 ) {
          return true;
        }
        else {
          return false;
        }
      }
    },

		metaInfo: {
            title: 'Pied Pro - Dre Rita El-Khoury, Podiatre Laval',
            htmlAttrs: {
                lang: 'en',
                amp: true
            }
        }
	};
</script>


<style lang="scss">
	@import '../../assets/scss/_variabls.scss';
    @import '../../assets/scss/page-section/_digital-agency.scss';
  .hero-item {
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    // responsive
    @media #{$desktop-device, $tablet-device}{
      height: 600px;
    }
    @media #{$large-mobile}{
      height: 450px;
    }
    @media #{$extra-small-mobile}{
      text-align: left;
      height: min-content;
      //width: 375px;
      margin: 0px;
    }
  }
  .hero-content {
    width: 750px;
    &-subtitle {
      color: $white;
      font-weight: 400;
      padding-bottom: 20px;
    }
    &-title {
      color: $white;
      font-size: 70px;
      margin-bottom: 0;
      // responsive
      @media #{$large-mobile}{
        font-size: 40px;
      }
      @media #{$small-mobile}{
        font-size: 28px;
      }
    }
    .sub-heading {
      color: $white;
      font-size: 16px;
      padding-top: 40px;
    }
    .hero-btn {
      margin-top: 40px;
      .ht-btn {
        margin-right: 30px;
        @media #{$extra-small-mobile}{
          margin-right: 5px;
        }
        &:last-child {
          margin-right: 0;
        }
        &--gradient2 {
          background: linear-gradient(90deg, rgb(240, 168, 107) 0%, rgb(225, 118, 67) 100%);
        }
      }
    }
  }

  .portrait{
    height: 600px;
    width: 425px;
    float: right;
    @media #{$desktop-device, $tablet-device}{
      height: 600px;
      width: 425px;
      float: none;
      background-position: center;
    }
    @media #{$large-mobile}{
      height: 450px;
      width: 325px;
      float: none;
      background-position: center;
    }
    @media #{$extra-small-mobile}{
      height: 330px;
      width: 225px;
      float: none;
      background-position: center;
    }
  }

  .text-service-separator {
    margin-inline: 7px;
    font-size: small;
    color: rgba(182, 128, 46, 0.4);
    @media #{$desktop-device, $tablet-device}{
      //height: 600px;
    }
    @media #{$large-mobile}{
      //height: 450px;
    }
    @media #{$extra-small-mobile}{
      margin-inline: 3px;
      font-size: small;
      color: rgba(182, 128, 46, 0.4);
    }
  }

  .divider {								/* minor cosmetics */
    display: table;
    font-size: 24px;
    text-align: center;
    width: 75%; 						/* divider width */
    margin: 40px auto;					/* spacing above/below */
  }
  .divider span { display: table-cell; position: relative; }
  .divider span:first-child, .divider span:last-child {
    width: 50%;
    top: 19px;							/* adjust vertical align */
    -moz-background-size: 100% 2px; 	/* line width */
    background-size: 100% 2px; 			/* line width */
    background-position: 0 0, 0 100%;
    background-repeat: no-repeat;
  }
  .divider span:first-child {				/* color changes in here */
    background-image: -webkit-gradient(linear, 0 0, 0 100%, from(transparent), to(#000));
    background-image: -webkit-linear-gradient(180deg, transparent, #000);
    background-image: -moz-linear-gradient(180deg, transparent, #000);
    background-image: -o-linear-gradient(180deg, transparent, #000);
    background-image: linear-gradient(90deg, transparent, #000);
  }
  .divider span:nth-child(2) {
    color: #000; padding: 0px 5px; width: auto; white-space: nowrap;
  }
  .divider span:last-child {				/* color changes in here */
    background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#000), to(transparent));
    background-image: -webkit-linear-gradient(180deg, #000, transparent);
    background-image: -moz-linear-gradient(180deg, #000, transparent);
    background-image: -o-linear-gradient(180deg, #000, transparent);
    background-image: linear-gradient(90deg, #000, transparent);
  }
</style>

